import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';

const BFM_Grid_Editor = (params) => {
    const { fields, data, onChange } = params;
    const [innerData, setInnerData] = useState({ fields, data });

    const _build_cell = (params) => {
        const { field, row_data, onChange } = params;

        const _build_input = () => {
            switch (field.fieldType) {
                case "datetime": {
                    return (<input type="datetime-local" className="form-control" onChange={(e) => {
                        if (e.target.valueAsNumber && !isNaN(e.target.valueAsNumber)) {
                            row_data[field.fieldName] = new Date(e.target.valueAsNumber);
                        } else {
                            row_data[field.fieldName] = null;
                        }

                        if (onChange) onChange(row_data);
                    }}
                        ref={(r) => {
                            if (!r) return;
                            if (row_data[field.fieldName] instanceof Date && !isNaN(row_data[field.fieldName])) {
                                r.valueAsNumber = new Date(row_data[field.fieldName]);
                            }
                            else {
                                if (row_data[field.fieldName]) {
                                    try {
                                        r.valueAsNumber = new Date(row_data[field.fieldName]);
                                    }
                                    catch (err) {
                                        r.valueAsNumber = null
                                    }
                                }
                            }
                        }}
                    ></input>)
                }
                    break;
                case "date": {
                    return (<input type="date" className="form-control" onChange={(e) => {
                        row_data[field.fieldName] = e.target.valueAsDate;
                        if (onChange) onChange(row_data);
                    }}
                        ref={(r) => {
                            if (!r) return;
                            if (row_data[field.fieldName] instanceof Date && !isNaN(row_data[field.fieldName])) {
                                r.valueAsDate = row_data[field.fieldName];
                            }
                            else {
                                if (row_data[field.fieldName]) {
                                    try {
                                        r.valueAsDate = new Date(row_data[field.fieldName]);
                                    }
                                    catch (err) {
                                        r.valueAsDate = null
                                    }
                                }
                            }
                        }}
                    ></input>)
                }
                    break;
                case "bool": {
                    return (
                        <div class="form-check  form-switch text-center">
                            <input className="form-check-input" type="checkbox" checked={row_data[field.fieldName] ? true : null}
                                onChange={(e) => {
                                    row_data[field.fieldName] = e.target.checked;
                                }}
                                ref={(r) => {
                                    if (!r) return;
                                }}
                            ></input>
                        </div>
                    )
                }
                    break;
                case "number": {
                    return (<input type="number" className="form-control" onChange={(e) => {
                        row_data[field.fieldName] = e.target.valueAsNumber;
                        if (onChange) onChange(row_data);
                    }}
                        ref={(r) => {
                            if (!r) return;
                            r.valueAsNumber = row_data[field.fieldName];
                        }}
                    ></input>)
                }
                    break;
                default: {
                    return (<input type="text" className="form-control" value={row_data[field.fieldName]} onChange={(e) => {
                        row_data[field.fieldName] = e.target.value;
                        if (onChange) onChange(row_data);
                    }}></input>)
                }
            }
        }

        return (<td>{_build_input()}</td>);
    }

    const _build_row = (params) => {
        const { fields, row_data, onChange, onDelete } = params;

        const _cells = fields.map((f) => {
            return _build_cell({
                field: f, row_data, onChange: (e) => {
                    if (onChange) onChange(e);
                }
            })
        });

        _cells.push((<td style={{ cursor: "pointer", textAlign: "center" }}
            onClick={(e) => {
                if (onDelete) onDelete(row_data);
            }}
        ><i class="fa fa-trash me-2 text-secondary"></i></td>));

        return (<tr>
            {<>{_cells.map((c) => c)}</>}
        </tr>);
    }

    const _build_rows = (params) => {
        const { fields, data, onChange } = params;

        return (<>{data.map((r) => _build_row({
            fields, row_data: r, onChange: (e) => {
                if (onChange) onChange(e);
            },
            onDelete: (e) => {
                data.splice(data.findIndex(x => x === e), 1);
                if (onChange) onChange(e);
            }
        }))}</>);
    }

    const _build_headers = (params) => {
        const { fields } = params;
        const _cells = fields.map((f) => (<th>{f.fieldName}</th>));
        _cells.push(<th></th>);

        return (<>{_cells.map((c) => c)}</>);
    }

    const _build_table = (params) => {
        return (<><table class="table">
            <thead>
                {_build_headers({ fields: innerData.fields })}
            </thead>
            <tbody>
                {_build_rows({
                    fields: innerData.fields, data: innerData.data, onChange: (e) => {
                        setInnerData({
                            fields: innerData.fields,
                            data: innerData.data
                        });
                        if (onChange) onChange(innerData.data);
                    }
                })}
            </tbody>
        </table>
            <div class="d-grid gap-2"> <button type="button" class="btn btn-primary" onClick={(e) => {
                innerData.data.push({});
                setInnerData({
                    fields: innerData.fields,
                    data: innerData.data
                });
            }}>+</button></div>
        </>
        )
    }

    return (<>{_build_table()}</>);
}

export { BFM_Grid_Editor }